import { Redirect } from "react-router-dom";
import { useLocation } from "react-router";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import { makeSelectAppLoggedIn } from "../../../app/appSelectors.js";
import { MobileRouterPaths } from "../../mobileAppConstants.js";
import React, { useCallback, useMemo, useState } from "react";
import Cookies from "universal-cookie";
import appHistory from "../../../app/appHistory.js";
import { logoutLiteTradeAction } from "../../../modules/LiteTrade/liteTradeActions.js";
import { MobileAppAuthStyled } from "./styled/MobileAppAuthStyled";
import MobileAppAuthPin from "./MobileAppAuthPin/MobileAppAuthPin";
import { MOBILE_APP_AUTH_STATE } from "./mobileAppAuthConstants";
import MobileAppAuthFingerprint from "./MobileAppAuthFingerprint/MobileAppAuthFingerprint";
import { useMobileAppAuthCurrentState } from "./mobileAppAuthHooks";
import { authRegisterMobileAppAction, authVerifyMobileAppAction } from "../../mobileAppActions";
import { logAppsflyerAction } from "../../../app/appActions";
import { LOG_AF_EVENT_NAMES } from "../../../app/appConstants";

const browserCookies = new Cookies();

function MobileAppAuth(props) {
    const location = useLocation();
    const {
        authRegister,
        authVerify,
        isLoggedIn,
        logout,
        logAppsflyer,
    } = props;

    const [state, setState] = useState('init');
    const [pinCode, setPinCode] = useState('');
    const [pinCode2, setPinCode2] = useState('');

    const pin = browserCookies.get('pin');
    const pinOk = browserCookies.get('pinOk');

    const handleNumClick = useCallback((num) => {
        if (state === MOBILE_APP_AUTH_STATE.PIN1 || state === MOBILE_APP_AUTH_STATE.ENTER_PIN) {
            setPinCode(`${pinCode}${num}`);
        }
        if (state === MOBILE_APP_AUTH_STATE.PIN2) {
            setPinCode2(`${pinCode2}${num}`);
        }
    }, [pinCode, pinCode2, state]);

    const handlePinClear = useCallback(() => {
        if (state === MOBILE_APP_AUTH_STATE.PIN1 || state === MOBILE_APP_AUTH_STATE.ENTER_PIN) {
            setPinCode(currentPinCode => currentPinCode.slice(0, -1));
        }
        if (state === MOBILE_APP_AUTH_STATE.PIN2) {
            setPinCode2(currentPinCode => currentPinCode.slice(0, -1));
        }
    }, [state]);

    const handleAuthVerify = useCallback(() => {
        authVerify({
            onFinallyCallback: () => {
                const pinOk = browserCookies.get('pinOk');
                const pin = browserCookies.get('pin');
                if (pinOk === pin) {
                    setState(MOBILE_APP_AUTH_STATE.DONE);
                    browserCookies.remove('pinCodeAttempts', {path: '/'});
                }
            }
        });
    }, [authVerify]);

    const handleStateCreateFinger = useCallback(() => {
        authRegister({
            onSuccessCallback: () => {
                setState(MOBILE_APP_AUTH_STATE.CREATE_FINGER_DONE);
                logAppsflyer({ name: LOG_AF_EVENT_NAMES.LOGIN_SET_FINGERPRINT });
            },
            onFailureCallback: () => {
                setState(MOBILE_APP_AUTH_STATE.DONE);
                logAppsflyer({
                    name: LOG_AF_EVENT_NAMES.LOGIN_ERROR,
                    payload: { error_code: 'error.set_fingerprint_failed' },
                });
            },
        });
    }, [authRegister, logAppsflyer]);

    const handleStateCreateFingerDone = useCallback(() => {
        setTimeout(() => {
            setState(MOBILE_APP_AUTH_STATE.DONE);
        }, 1000);
    }, []);

    const handleStateDone = useCallback(() => {
        appHistory.push(MobileRouterPaths.default, {
            search: location.search,
            originPathname: location.pathname,
            originSearch: location.search
        });
    }, [location]);

    const handleStateEnterPin = useCallback(() => {
        if (pinCode.length === 4) {
            if (pinCode === pin) {
                browserCookies.set('pinOk', pinCode, {path: '/', maxAge: 60 * 5});
                browserCookies.remove('pinCodeAttempts', {path: '/'});
                setState(MOBILE_APP_AUTH_STATE.DONE);
                setPinCode('');
                logAppsflyer({
                    name: LOG_AF_EVENT_NAMES.LOGIN_COMPLETED,
                    payload: { method: 'pin' },
                });
            } else {
                const pinCodeAttempts = parseInt(browserCookies.get('pinCodeAttempts')) || 0;
                const currentAttempt = pinCodeAttempts + 1;
                logAppsflyer({
                    name: LOG_AF_EVENT_NAMES.LOGIN_ERROR,
                    payload: {
                        method: 'error.incorrect_pin_code_on_login',
                        attempt: currentAttempt,
                    },
                });
                if (currentAttempt < 3) {
                    browserCookies.set('pinCodeAttempts', pinCodeAttempts + 1, {path: '/', maxAge: 60 * 60 * 24 * 365})
                    setTimeout(() => {
                        setPinCode('');
                    }, 500);
                } else {
                    logout();
                    browserCookies.remove('pinCodeAttempts', {path: '/'});
                }
            }
        }
    }, [logAppsflyer, logout, pin, pinCode]);

    const handleStateInit = useCallback(() => {
        if (!pin) {
            setState(MOBILE_APP_AUTH_STATE.PIN1);
        } else if (pin === pinOk) {
            setState(MOBILE_APP_AUTH_STATE.DONE);
        } else {
            setState(MOBILE_APP_AUTH_STATE.ENTER_PIN);
        }
    }, [pin, pinOk]);

    const handleStatePin1 = useCallback(() => {
        if (pinCode.length === 4) {
            setState(MOBILE_APP_AUTH_STATE.PIN2);
            logAppsflyer({ name: LOG_AF_EVENT_NAMES.LOGIN_CREATE_PIN });
        }
    }, [logAppsflyer, pinCode]);

    const handleStatePin2 = useCallback(() => {
        if (pinCode2.length === 4) {
            if (pinCode === pinCode2) {
                logAppsflyer({ name: LOG_AF_EVENT_NAMES.LOGIN_CONFIRM_PIN });
                browserCookies.set('pin', pinCode, {path: '/', maxAge: 60 * 60 * 24 * 365});
                browserCookies.set('pinOk', pinCode, {path: '/', maxAge: 60 * 5});
                browserCookies.remove('pinCodeAttempts', {path: '/'});
                setTimeout(() => {
                    setState(MOBILE_APP_AUTH_STATE.ASK_USE_FINGER);
                }, 500);
            } else {
                logAppsflyer({
                    name: LOG_AF_EVENT_NAMES.LOGIN_ERROR,
                    payload: { error_code: 'error.confirm_pin_is_not_correct' },
                });
                setTimeout(() => {
                    setPinCode2('');
                    setPinCode('');
                    setState(MOBILE_APP_AUTH_STATE.PIN1);
                }, 500);
            }
        }
    }, [logAppsflyer, pinCode, pinCode2]);

    useMobileAppAuthCurrentState(state, MOBILE_APP_AUTH_STATE.CREATE_FINGER, handleStateCreateFinger);
    useMobileAppAuthCurrentState(state, MOBILE_APP_AUTH_STATE.CREATE_FINGER_DONE, handleStateCreateFingerDone);
    useMobileAppAuthCurrentState(state, MOBILE_APP_AUTH_STATE.DONE, handleStateDone);
    useMobileAppAuthCurrentState(state, MOBILE_APP_AUTH_STATE.ENTER_PIN, handleStateEnterPin);
    useMobileAppAuthCurrentState(state, MOBILE_APP_AUTH_STATE.INIT, handleStateInit);
    useMobileAppAuthCurrentState(state, MOBILE_APP_AUTH_STATE.PIN1, handleStatePin1);
    useMobileAppAuthCurrentState(state, MOBILE_APP_AUTH_STATE.PIN2, handleStatePin2);

    const handleSetupFingerprint = useCallback(() => {
        setState(MOBILE_APP_AUTH_STATE.CREATE_FINGER);
        logAppsflyer({
            name: LOG_AF_EVENT_NAMES.LOGIN_FINGERPRINT,
            payload: { button: 'set_up' },
        });
    }, [logAppsflyer]);

    const handleSkipSetupFingerprint = useCallback(() => {
        setState(MOBILE_APP_AUTH_STATE.DONE);
        logAppsflyer({
            name: LOG_AF_EVENT_NAMES.LOGIN_FINGERPRINT,
            payload: {  button: 'skip' },
        });
    }, [logAppsflyer]);

    const {isEqual: isPinCodesEqual, isWrong: isPinCodesWrong} = useMemo(() => {
        const pinCodeToCompare = state === MOBILE_APP_AUTH_STATE.ENTER_PIN ? pin : pinCode2;
        if (pinCode.length !== 4 || pinCodeToCompare.length !== 4) {
            return { isEqual: false, isWrong: false }
        }
        return {
            isEqual: pinCode === pinCodeToCompare,
            isWrong: pinCode !== pinCodeToCompare,
        }
    }, [pin, pinCode, pinCode2, state]);

    if (!isLoggedIn) {
        return <Redirect to={{
            pathname: location.state?.originPathname || MobileRouterPaths.default,
            search: location.state?.originSearch,
        }}/>
    }

    return <MobileAppAuthStyled>
        {
            [MOBILE_APP_AUTH_STATE.ENTER_PIN, MOBILE_APP_AUTH_STATE.PIN1, MOBILE_APP_AUTH_STATE.PIN2].includes(state) &&
            <MobileAppAuthPin
                authVerify={handleAuthVerify}
                isPinCodesEqual={isPinCodesEqual}
                isPinCodesWrong={isPinCodesWrong}
                onNumClick={handleNumClick}
                onPinClear={handlePinClear}
                pinCode={state === MOBILE_APP_AUTH_STATE.PIN2 ? pinCode2 : pinCode}
                state={state}
            />
        }
        {
            [MOBILE_APP_AUTH_STATE.ASK_USE_FINGER, MOBILE_APP_AUTH_STATE.CREATE_FINGER_DONE].includes(state) &&
            <MobileAppAuthFingerprint
                state={state}
                onSetupFingerprint={handleSetupFingerprint}
                onSkipSetupFingerprint={handleSkipSetupFingerprint}
            />
        }
    </MobileAppAuthStyled>
}

const mapStateToProps = createStructuredSelector({
    isLoggedIn: makeSelectAppLoggedIn(),
})

const mapDispatchToProps = (dispatch) => ({
    authRegister: payload => dispatch(authRegisterMobileAppAction(payload)),
    authVerify: payload => dispatch(authVerifyMobileAppAction(payload)),
    logAppsflyer: payload => dispatch(logAppsflyerAction(payload)),
    logout: payload => dispatch(logoutLiteTradeAction(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(MobileAppAuth);
